import React from 'react';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import { lazyAfterPaint } from '@atlassian/react-loosely-lazy';
import { JSErrorBoundary } from '@jira/platform__js-error-boundary/src/JSErrorBoundary.tsx';

const LazyJsmCustomDomainChangeBoardingFlag = lazyAfterPaint(
	() =>
		import(
			/* webpackChunkName: "async-jsm-custom-domain-change-boarding-flag" */ './JsmCustomDomainChangeBoardingFlag.tsx'
		),
	{ entryFsSsrLiftImportToModule: true },
);

export const AsyncJsmCustomDomainChangeBoardingFlag = (): React.JSX.Element => {
	return (
		<JSErrorBoundary
			id="async-jsm-custom-domain-change-boarding-flag"
			packageName="jira-help-center-custom-domain-change-boarding"
		>
			<Placeholder name="jsm-custom-domain-change-boarding-flag" fallback={null}>
				<LazyJsmCustomDomainChangeBoardingFlag />
			</Placeholder>
		</JSErrorBoundary>
	);
};
